import { motion } from "framer-motion";

export function PagodaMark({ className = "w-6 h-6" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path d="M12 1.5 L12 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      <circle cx="12" cy="1.4" r="0.9" fill="currentColor" />
      <path d="M12 4 L7.5 9 H16.5 L12 4 Z" fill="currentColor" opacity="0.9" />
      <path d="M5.5 12.5 H18.5 L16.5 9.5 H7.5 L5.5 12.5 Z" fill="currentColor" opacity="0.75" />
      <path d="M4 16.5 H20 L18.2 13.5 H5.8 L4 16.5 Z" fill="currentColor" opacity="0.6" />
      <rect x="6" y="17.5" width="12" height="2.2" rx="0.6" fill="currentColor" opacity="0.85" />
      <rect x="8" y="20.5" width="8" height="1.8" rx="0.5" fill="currentColor" />
    </svg>
  );
}

export function Diamond({ className = "w-2 h-2" }) {
  return (
    <svg viewBox="0 0 8 8" className={className} aria-hidden="true">
      <rect x="1.7" y="1.7" width="4.6" height="4.6" transform="rotate(45 4 4)" fill="currentColor" />
    </svg>
  );
}

export function AcheikDivider({ className = "" }) {
  return (
    <div className={`acheik-bg h-7 w-full ${className}`} aria-hidden="true" />
  );
}

export function SectionHeading({ overline, title, sub, align = "left", dark = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`mb-10 ${align === "center" ? "text-center" : ""}`}
      data-testid={`section-heading-${(overline || "section").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    >
      {overline && (
        <p className={`text-xs font-semibold uppercase tracking-[0.22em] mb-3 ${dark ? "text-gold" : "text-ruby"}`}>
          {overline}
        </p>
      )}
      <h2 className={`font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight ${dark ? "text-cream" : "text-ink"}`}>
        {title}
      </h2>
      {sub && <p className={`mt-3 text-base leading-relaxed max-w-2xl ${align === "center" ? "mx-auto" : ""} ${dark ? "text-cream/70" : "text-clay"}`}>{sub}</p>}
    </motion.div>
  );
}
